import CommonBase from "./CommonBase";
import {Component, Inject, Watch} from "vue-property-decorator";
import BaseApi from "../store/modules/base";
import {CardUserdata, Person} from "../modules/models";
import {NotAuthenticated} from "@/modules/PlayServerClient";

@Component
export default class UserRequired extends CommonBase {
    @Inject()
    baseApi!: BaseApi;

    private emptyCardUserdata() {
        const emptyPerson = new Person("", null, null, null, null, null, null);
        return new CardUserdata(emptyPerson, [], [], [], false, [],
            [], [], null, [], []);
    }

    get user(): CardUserdata {
        return this.baseApi.user || this.emptyCardUserdata();
    }

    @Watch("user", {immediate: true})
    onUserChange() {
        if(this.user == null || this.user.person.guid === "") {
            throw new NotAuthenticated("Siden krever innlogging");
        }
    }
}